export const navLinks = [
  {
    name: "Home",
    href: "/",
  },
  {
    name: "Work",
    href: "/#work",
  },
  {
    name: "Rates",
    href: "/#pricing",
  },
  {
    name: "About",
    href: "/#about",
  },
];
